/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('CarRentalTypeFactory', function($resource) {
	return $resource(
		'api/carRentalTypes/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewCarRentalTypeFactory', function($resource) {
	return $resource(
		'api/carRentalTypes/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all CarRentalTypes without the use of paging
angular.module('emsApp').factory('NoPagingCarRentalTypeFactory', function($resource) {
	return $resource(
		'api/carRentalTypes/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('CarsByCarRentalTypeFactory', function($resource) {
	return $resource(
		'api/cars/carRentalType/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllCarRentalTypesByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/carRentalTypes/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllCarRentalTypesByQueryParamsNonPageableFactory', function($resource) {
	return $resource(
		'api/query/carRentalTypesNonPageable/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});
